import {Dispatch} from "redux";
import {ActionType} from "../actionTypes";
import {TAddToMyListOneItemPopupActions} from "../actions/addToMyListOneItemPopupActions";
import {AddToMyListForOneItemPopupDataDto, IFlyerRuntimePageSpotItem} from "../../dtos/flyer";

export const setAddToMyListOneItemData = (data: AddToMyListForOneItemPopupDataDto | null, isLoading?: boolean) => {
    return async (dispatch: Dispatch<TAddToMyListOneItemPopupActions>) => {
        dispatch({
            type: ActionType.SET_DATA_TO_ADD_TO_MY_LIST_ONE_ITEM,
            payload: {
                data: data,
                isLoading: isLoading ? isLoading : false
            },
        })
    };

}

export const toggleLoadingForAddToMyListOneItemData = (isLoading: boolean) => {
    return async (dispatch: Dispatch<TAddToMyListOneItemPopupActions>) => {
        dispatch({
            type: ActionType.TOGGLE_LOADING_DATA_FOR_ADD_TO_MY_LIST_ONE_ITEM,
            payload: isLoading,
        })
    };

}

export const changeTargetItem = (targetItem: IFlyerRuntimePageSpotItem) => {
    return async (dispatch: Dispatch<TAddToMyListOneItemPopupActions>) => {
        dispatch({
            type: ActionType.CHANGE_TARGET_ITEM,
            payload: targetItem,
        })
    };
}
